import React, { Component } from 'react';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';

import './SmallButton.css';

@inject('translationsStore')
@observer
export default class SmallButton extends Component {
  render() {
    const cls = classNames({
      SmallButton: true
    });
    return (
      <div className={cls} onClick={this.props.onClick} style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/DriversTable/SmallButton/SmallButton.js